import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

import _ from 'lodash';


// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  app.config.globalProperties.$_ = _;

  app.config.globalProperties.$invoke = async (action, before, after) => {
    before && before();
    await action();
    after	&& after();
  };

  const on = app.config.globalProperties.$on
  app.config.globalProperties.$on = (event, func) => {
    let newFunc = func
    if (event == 'click') {
      newFunc = _.debounce(function() {
        func.apply(this, arguments)
      }, 1000, {leading: true, trailing: false}) // 1000表示防抖的延迟时间，单位为毫秒
      on.call(this, 'click', newFunc)
    }else {
      on.call(this, event, newFunc)
    }
  };

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  app.mount('#app')
}

setupAll()
